setTimeout(() => {
class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
      document.querySelector(".shopify-section-header-sticky").style.zIndex = 100;
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper') || this.closest('.st-product-card');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          // Re-init QV thumbnails after fresh HTML is injected
          const qvWrapper = drawerContent.querySelector('[id^="QvThumbnails-"]');
          if (qvWrapper) {
            const sectionId = qvWrapper.id.replace('QvThumbnails-', '');
            if (typeof window.initQvThumbnails === 'function') {
              window.initQvThumbnails(sectionId);
            }
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');
          document.querySelector(".shopify-section-header-sticky").style.zIndex = 30;
          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;
    document.dispatchEvent(new CustomEvent("swym:model-loaded"));
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);


/* ----------------------------------------
   RE-FILTER THUMBNAILS ON VARIANT CHANGE
   Hooks into productInfo:loaded which fires
   after VariantSelects.renderProductInfo()
---------------------------------------- */

document.addEventListener('productInfo:loaded', function() {

  var qvWrapper = document.querySelector('[id^="QvThumbnails-"]');
  if(!qvWrapper) return;

  var sectionId = qvWrapper.id.replace('QvThumbnails-', '');

  // Use variant-radios (not variant-selects) as this theme uses radio inputs
  var vs = document.querySelector('quick-view-drawer details[open] variant-radios') ||
           document.querySelector('quick-view variant-radios') ||
           document.querySelector('variant-radios');

  if(!vs || !vs.currentVariant) return;

  var optionValues    = vs.currentVariant.options || [];
  var featuredMediaId = vs.currentVariant.featured_media
    ? vs.currentVariant.featured_media.id
    : null;

  var thumbList  = document.getElementById('QvThumbList-' + sectionId);
  var mainSlider = document.getElementById('Slider-' + sectionId);
  if(!thumbList || !mainSlider) return;

  var visibleThumbs     = 0;
  var firstVisibleThumb = null;

  var headingEl   = document.querySelector('quick-view-drawer details[open] .product__heading');
  var headingText = headingEl ? headingEl.innerText.toLowerCase().trim() : '';

  thumbList.querySelectorAll('.qv-thumbnail__item').forEach(function(item) {

    var img = item.querySelector('img');
    if(!img) return;

    var alt     = img.alt ? img.alt.toLowerCase().trim() : '';
    var matched = false;

    if(headingText && alt === headingText) {
      matched = true;
    } else if(alt === 'i&') {
      matched = true;
    } else {
      optionValues.forEach(function(opt) {
        if(!opt) return;
        var normalized = opt.toLowerCase().trim().replace(/\s+/g, '');
        if(
          alt === normalized ||
          alt.replace(/\s+/g, '') === normalized ||
          alt.includes(normalized)
        ) {
          matched = true;
        }
      });
    }

    // Always show featured image of selected variant
    var mediaIdPart = (item.getAttribute('data-thumb-media-id') || '').split('-').pop();
    if(featuredMediaId && featuredMediaId.toString() === mediaIdPart) {
      matched = true;
    }

    item.style.display = matched ? 'block' : 'none';

    if(matched) {
      if(!firstVisibleThumb) firstVisibleThumb = item;
      visibleThumbs++;
    }

  });

  // Fallback: show all if nothing matched
  if(visibleThumbs === 0) {
    thumbList.querySelectorAll('.qv-thumbnail__item').forEach(function(item) {
      item.style.display = 'block';
    });
    firstVisibleThumb = thumbList.querySelector('.qv-thumbnail__item');
  }

  // Set active thumb and scroll main slider
  if(firstVisibleThumb) {
    thumbList.querySelectorAll('.qv-thumbnail__item').forEach(function(t) {
      t.classList.remove('qv-thumbnail__item--active');
    });
    firstVisibleThumb.classList.add('qv-thumbnail__item--active');

    var mediaId = firstVisibleThumb.getAttribute('data-thumb-media-id');
    var slide   = mainSlider.querySelector('[data-media-id="' + mediaId + '"]');
    if(slide) {
      mainSlider.scrollTo({
        left: slide.offsetLeft,
        behavior: 'auto'
      });
    }
  }

  thumbList.scrollTo({ left: 0 });

});

}, 0)